import { useQuery } from "@tanstack/react-query";

import { axios } from "@/client/libs/axios";

export type AiUsage = {
  used: number;
  usedTokens: number;
  tokenBudget: number; // 0 means unlimited
  tokenBalance?: number; // purchased top-up tokens
  plan: string;
  viaOrganization?: boolean;
};

export const fetchAiUsage = async () => {
  const response = await axios.get<AiUsage>("/ai/usage");

  return response.data;
};

export const useAiUsage = () => {
  const { data, error, isPending } = useQuery({
    queryKey: ["ai-usage"],
    queryFn: fetchAiUsage,
  });

  return { usage: data, loading: isPending, error };
};
